function updateOptionLegend(inputID) {
  var input = document.getElementById(inputID);
  var legend = document.querySelector('.product-form__input[data-option="' + input.name + '"] span.legend-selected-option');
  legend.innerHTML = input.value;
}

function updateSizeLegend() {
  var $legend = document.getElementById('legend-selected-size'),
    currentType = document.querySelector('.size-type-buttons .active').dataset.sizeType,
    currentSize = document.querySelector('.product-size-option-container input:checked+label span.active').innerHTML;

  $legend.innerHTML = currentType.replace('-', ' ') + ' ' + currentSize;
  $legend.dataset.sizeType = currentType;
  $legend.dataset.sizeValue = currentSize;
}

// Init PM product swatches swiper on load
try {
  var $swatches = document.getElementById('product-swatches'),
    groupTag = $swatches.dataset.groupTag,
    productId = $swatches.dataset.productId,
    url = `/collections/all/${groupTag}?view=pm-product-swatches`;

  fetch(url).then((response) => {
    if (response.ok) {
      return response.text();
    }
  })
    .then((html) => {
      $swatches.innerHTML += html;
      var currentSwatch = $swatches.querySelector('.swatch[data-product-id="' + productId + '"]');
      if (currentSwatch) {
        currentSwatch.classList.add('selected');
      }
    });
  $swatches.initialize();
} catch (e) {
  console.log('Error rendering swatches: ' + e);
};

// Update option legend on variant change
document.querySelectorAll('.product-form__input input[type="radio"]:not(.size-input)').forEach(function (input) {
  input.addEventListener('click', function () {
    updateOptionLegend(input.id)
  })
})

// Update size legend on variant change
document.querySelectorAll('.product-size-option-container input.size-input').forEach(function (input) {
  input.addEventListener('click', function () {
    updateSizeLegend()
  })
})

// Update Store Availability width on variant change
document.querySelectorAll('.product-form__input[data-option="Width"] input').forEach(function (width) {
  width.addEventListener('click', function() {
    document.getElementById('store-availability-width').value = width.value;
  });
});
setTimeout(function(){
  // Update it on page load also - need to skip a beat for the extension to load first
  let $width = document.querySelector('.product-form__input[data-option="Width"] input:checked');
  let $storeAvailWidth = document.getElementById('store-availability-width');
  $storeAvailWidth.value = $width.value;
},2000);

// Size converter
function convertSizes(buttonID) {
  var sizeButton = document.getElementById(buttonID);
  //indicate the size type has been selected
  document.querySelector('.size-converter-button.active').classList.remove('active');
  sizeButton.classList.add('active');
  //hide all size labels
  var sizeType = sizeButton.dataset.sizeType;
  var labels = document.getElementsByClassName('size-label');
  for (var i = 0; i < labels.length; i++) {
    labels[i].classList.remove('active');
  }
  //show the size labels of the selected size
  var labels_to_display = document.getElementsByClassName(sizeType);
  for (var i = 0; i < labels_to_display.length; i++) {
    labels_to_display[i].classList.add('active');
  }
  // update size legend
  updateSizeLegend()
}

// Used to add click events to the buttons
function toArray(list) {
  return Array.prototype.slice.call(list);
}

// Triggers
var sizeButtons = toArray(document.getElementsByClassName('size-converter-button'));
sizeButtons.forEach(function (sizeButton) {
  document.getElementById(sizeButton.id).addEventListener(
    'click',
    function () {
      convertSizes(sizeButton.id);
    },
    false
  );
});

// Load Yotpo reviews
var yotpo_key = 'FTVyytJpTz07eAZ8nIuGjsCyXM5o7JglqXJFeiiZ',
    reviews_url = `https://api-cdn.yotpo.com/v3/storefront/store/${yotpo_key}/product/${productId}/reviews`;
fetch(reviews_url)
  .then((response) => response.json())
  .then((data) => {

    let productReviews = data.reviews;
    let reviewArray = [];

    console.log('[yotpo]',data.reviews.length,'reviews loaded')

    productReviews.forEach(function (item) {
      reviewArray.push({
        "@type": "Review",
        reviewRating: {
          "@type": "Rating",
          ratingValue: item.score,
        },
        author: {
          "@type": "Person",
          name: item.user.display_name,
        },
      });
    });

    if (productReviews) {
      let reviews = {
        review: reviewArray,
      };

      let prodJson = document.getElementById("product_schema");
      let str = prodJson.innerHTML;
      let strReviews = JSON.stringify(reviews);
      strReviews = strReviews.slice(1).slice(0, -1);

      str = str.replace(
        '"@id": "Product",',
        '"@id": "Product", ' + strReviews + ","
      );
      prodJson.innerHTML = str;
    }
  })
  .catch((err) => console.error(err));